import styled from 'styled-components'

import theme, {media} from '@/src/config/theme'

import Button from '@/src/shared/ui/button'
import RunlabModal from '@/src/shared/ui/modal'
import {NextLink as Link} from '@/src/shared/ui/next-link'

import {CollapseUI} from './collapsable-info'

export const Title = styled.div`
  font-size: 1.25rem;
  font-weight: 450;
`

export const InfoRow = styled(CollapseUI.InfoRow)`
  display: flex;
  flex-direction: row;

  justify-content: space-between;

  padding: 15px 0;
  background: white;
  border: unset;

  ${CollapseUI.ListItemContent} & {
    padding-bottom: 20px;
  }
  ${CollapseUI.InfoColumn} & {
    padding-bottom: 20px;

    border-bottom: solid 1px ${theme.colors.gray6};

    &:last-child {
      border-bottom: unset;
    }
  }
`

export const PaymentTotalInfo = styled(InfoRow)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  & > span {
    width: unset;
  }
`

export const PriceInfo = styled(InfoRow)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: unset;
  justify-content: flex-end;
  gap: 0;

  & > span {
    width: unset;
  }
`

export const PaymentInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const OrderStatus = styled.div``

export const OrderTotal = styled.div`
  font-size: 1.125rem;
  font-weight: 450;
`
export const OrderDate = styled.div``

export const ProductRow = styled(CollapseUI.Row)`
  gap: 10px;

  border-top: unset;
  border-bottom: solid 1px ${theme.colors.gray6};

  @media ${media.md} {
    gap: 32px;
  }
`

export const ProductImage = styled.div`
  width: 97px;
  height: 97px;

  justify-content: center;
  display: flex;

  & > img {
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;

    height: auto;
    width: auto;
  }
`

export const ProductContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const ProductName = styled(Link)`
  font-size: 1rem;

  @media ${media.md} {
    font-size: 1.125rem;
  }
`

export const ProductOffers = styled.div``

export const ProductVariant = styled.div`
  font-size: 1.125rem;
  display: flex;
  gap: 5px;
`

export const ProductPrice = styled.div`
  padding-top: 12px;

  font-weight: 450;
  font-size: 1.125rem;
`

export const ProductAttributeName = styled.div`
  font-weight: 450;
`

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;
`

export const TotalInfo = styled.div`
  padding-top: 20px;

  display: flex;
  justify-content: space-between;
  gap: 10px;

  border-top: solid 1px black;
`

export const BuyButton = styled(Button)`
  span {
    font-size: 1.125rem;
  }
`

export const LoadingWrapper = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Modal = styled(RunlabModal)`
  &.ant-modal {
    width: unset !important;
  }

  &.ant-modal .ant-modal-close {
    display: none;
  }

  &.ant-modal .ant-modal-content {
    background: transparent;
    box-shadow: unset;
    padding: 20px;
  }
`

export const ContainerLimited = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 716px;
`
